import { mergeProps as _mergeProps, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id", "placeholder", "aria-label", "aria-describedby", "aria-required", "aria-invalid"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(_component_Field, {
    name: _ctx.name,
    modelValue: _ctx.maskedValue,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.maskedValue) = $event))
  }, {
    default: _withCtx(({ field }) => [
      _withDirectives(_createElementVNode("input", _mergeProps({
        id: _ctx.campoId,
        type: "text",
        class: "form-control",
        ref: "input"
      }, field, {
        onMaska: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.emits && _ctx.emits(...args))),
        onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.emits && _ctx.emits(...args))),
        placeholder: _ctx.$props.placeholder,
        "aria-label": _ctx.ariaLabel || undefined,
        "aria-describedby": _ctx.describedBy || undefined,
        "aria-required": _ctx.required ? 'true' : undefined,
        "aria-invalid": _ctx.invalido ? 'true' : undefined
      }), null, 16, _hoisted_1), [
        [_directive_maska, { 'mask': _ctx.mask, 'tokens': _ctx.tokens }]
      ])
    ]),
    _: 1
  }, 8, ["name", "modelValue"]))
}